import { Injectable } from "@angular/core";
import { environment } from "../../../../../../environments/environment";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { ListProductResponse } from "../interfaces/list-products-new.interface";

@Injectable({
  providedIn: 'root'
})
export class ListProductsService {
  private readonly apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) { }
  listProducts(establishmentId: string): Observable<ListProductResponse> {
    return this.http.get<ListProductResponse>(`${this.apiUrl}/getAllProducts/${establishmentId}`);
  }

  listProductsLogin(id_user: number, id_address: number): Observable<ListProductResponse> {
    return this.http.get<ListProductResponse>(`${this.apiUrl}/getAllProducts/${id_user}?id_address=${id_address}`);
  }
}
